
  import { Component, Vue } from 'vue-property-decorator'

  @Component
  export default class ScheduleBtn extends Vue {
  // Methods
    goToSchedule = () => {
      this.$router.push({
        name: 'schedule',
      })
    }

  // Getters

  // Watchers
  }
